import { getToken } from "../services/api/api-util";

export let config = (method = "GET", query = false) => {
   let token = getToken();
  if (query)
  {
    return {
      method: method,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  } else {
    return {
      method: method,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
};
